<template>
	<main class="privacy-policy-page">

		<!-- Header -->
		<theme-header />

		<!-- Breadcrumb -->
		<breadcrumb title="dLab - Privacy Policy" subpage="pages" currentpage="privacy-policy" />

        <!-- Privacy Policy Content -->
        <privacy-policy-content />

		<!-- Footer -->
        <theme-footer />

        <back-to-top btnText="Back to top" :showIcon="true" />

    </main>
</template>

<script>
import ThemeFooter from '../components/common/ThemeFooter.vue'
import ThemeHeader from '../components/common/ThemeHeader.vue'
import BackToTop from '../components/pieces/BackToTop.vue'
import Breadcrumb from '../components/pieces/Breadcrumb.vue'
import PrivacyPolicyContent from '../components/sections/PrivacyPolicyContent.vue'

export default {
    name: 'PrivacyPolicy',
    components: {
        ThemeHeader,
        Breadcrumb,
        ThemeFooter,
        BackToTop,
        PrivacyPolicyContent
    }
}
</script>